import api from "src/apis/api"

function buildParams({ from, to, project_id, pipeline_id, source, rep_id } = {}) {
  const params = new URLSearchParams()
  if (from) params.set("from", from)
  if (to) params.set("to", to)
  if (project_id) params.set("project_id", project_id)
  if (pipeline_id) params.set("pipeline_id", pipeline_id)
  if (source) params.set("source", source)
  if (rep_id) params.set("rep_id", rep_id)
  return params
}

export async function fetchOverview(filters = {}) {
  const params = buildParams(filters)
  const { data } = await api.get(`/api/v1/analytics/overview?${params}`)
  return data
}

export async function fetchFunnel(filters = {}) {
  const params = buildParams(filters)
  if (filters.by) params.set("by", filters.by)
  const { data } = await api.get(`/api/v1/analytics/funnel?${params}`)
  return data
}

export async function fetchVelocity(filters = {}) {
  const params = buildParams(filters)
  const { data } = await api.get(`/api/v1/analytics/velocity?${params}`)
  return data
}

export async function fetchWinLoss(filters = {}) {
  const params = buildParams(filters)
  const { data } = await api.get(`/api/v1/analytics/win_loss?${params}`)
  return data
}

export async function fetchCollections(filters = {}) {
  const params = buildParams(filters)
  const { data } = await api.get(`/api/v1/analytics/collections?${params}`)
  return data
}

export async function fetchInventory(filters = {}) {
  const params = buildParams(filters)
  const { data } = await api.get(`/api/v1/analytics/inventory?${params}`)
  return data
}

export async function fetchWebsiteEnquiries(filters = {}) {
  const params = buildParams(filters)
  const { data } = await api.get(`/api/v1/analytics/website_enquiries?${params}`)
  return data
}

export function exportUrl(report, filters = {}) {
  const params = buildParams(filters)
  return `/api/v1/analytics/export/${report}?${params}`
}
